import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const ScrollContainer = styled(motion.div)`
  position: fixed;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
  color: #fff;
  mix-blend-mode: difference;
`;

const ScrollText = styled.p`
  font-size: 0.85rem;
  font-weight: 400;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 2px;
  opacity: 0.8;
`;

const ArrowContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Arrow = styled(motion.div)`
  width: 15px;
  height: 15px;
  border-right: 2px solid #fff;
  border-bottom: 2px solid #fff;
  transform: rotate(45deg);
  margin-bottom: 4px;
`;

const ScrollIndicator = () => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Vérifier la position initiale du défilement
    const checkInitialScroll = () => {
      if (window.scrollY > 200) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    };
    
    // Vérifier immédiatement au chargement
    checkInitialScroll();
    
    // Show the scroll indicator after a delay only if at the top
    const timeout = setTimeout(() => {
      if (window.scrollY < 50) {
        setVisible(true);
      }
    }, 1500);

    // Handle scroll to hide the indicator when scrolled
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setVisible(false);
      } else if (window.scrollY === 0) {
        setVisible(true);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      clearTimeout(timeout);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const arrowVariants = {
    animate: {
      y: [0, 5, 0],
      opacity: [0.5, 1, 0.5],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        repeatType: "loop",
      },
    },
  };

  return (
    <AnimatePresence>
      {visible && (
        <ScrollContainer
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
        >
          <ScrollText>{t('home.scrollDown')}</ScrollText>
          <ArrowContainer variants={arrowVariants} animate="animate">
            <Arrow />
            <Arrow />
          </ArrowContainer>
        </ScrollContainer>
      )}
    </AnimatePresence>
  );
};

export default ScrollIndicator;